// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f8T6hNCGtnbTva8MFOvV{filter:blur(5px);user-select:none;pointer-events:none}`, "",{"version":3,"sources":["webpack://./web/src/components/common/PriceDisplay/PriceDisplay.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACA,gBAAA,CACA,mBAAA","sourcesContent":[".blurred {\n  filter: blur(5px);\n  user-select: none;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blurred": `f8T6hNCGtnbTva8MFOvV`
};
export default ___CSS_LOADER_EXPORT___;
